export const BILLING_ENABLED = false;
export const PRICING_ENABLED = false;
